// extracted by mini-css-extract-plugin
export default {"buttonContainer":"_3S9h4","alignToEdge":"FGNUm","buttonIcon":"PQDba","buttonCaption":"B1NzR","buttonSpacer":"bi6IM"};